module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "newReservationModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Add Reservation\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("To add reservation, enter contact details")]), _vm._v(" "), _c('div', {
    staticClass: "ui top attached segment"
  }, [_c('form', {
    staticClass: "ui contact-details form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.reserve($event)
      }
    }
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Number of People")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.numPeople),
      expression: "details.numPeople"
    }],
    attrs: {
      "type": "number",
      "name": "numPeople",
      "placeholder": "Enter number"
    },
    domProps: {
      "value": (_vm.details.numPeople)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.numPeople = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Select reason")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details._reason),
      expression: "details._reason"
    }],
    staticClass: "ui selection dropdown",
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.details._reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.reasons), function(reason) {
    return _c('option', {
      domProps: {
        "value": reason._id
      }
    }, [_vm._v(_vm._s(reason.title))])
  })], 2)])]), _vm._v(" "), _vm._l((_vm.additionalServices), function(additionalService) {
    return _c('div', {
      staticClass: "service list item"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "large green checkmark icon",
      class: {
        'green checkmark': additionalService.selected, 'grey delete': !additionalService.selected
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n            " + _vm._s(additionalService.title) + "\n            "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                          " + _vm._s(additionalService.description) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      class: {
        'strong': additionalService.selected
      }
    }, [_vm._v("€ " + _vm._s(_vm.numeral(additionalService.price).format('0,0.00'))), (additionalService.priceType === 'perPerson') ? _c('span', [_vm._v(" / person")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "select"
    }, [_c('div', {
      staticClass: "ui basic tiny buttons"
    }, [(!additionalService.selected) ? _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.toggleService(additionalService)
        }
      }
    }, [_c('i', {
      staticClass: "checkmark icon"
    }), _vm._v(" Select")]) : _c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.toggleService(additionalService)
        }
      }
    }, [_c('i', {
      staticClass: "delete icon"
    }), _vm._v(" Remove")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("Additional wishes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.wishes),
      expression: "details.wishes"
    }],
    attrs: {
      "name": "wishes",
      "rows": "2",
      "placeholder": "Specify additional wishes to track"
    },
    domProps: {
      "value": (_vm.details.wishes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.wishes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Additional questions")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.questions),
      expression: "details.questions"
    }],
    attrs: {
      "name": "questions",
      "rows": "2",
      "placeholder": "Specify additional questions to track"
    },
    domProps: {
      "value": (_vm.details.questions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.questions = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Voucher")]), _vm._v(" "), _c('div', {
    staticClass: "ui right icon input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.voucher),
      expression: "details.voucher"
    }],
    attrs: {
      "type": "text",
      "name": "voucher",
      "placeholder": "Enter voucher"
    },
    domProps: {
      "value": (_vm.details.voucher)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.voucher = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "barcode icon"
  })])]), _vm._v(" "), _c('div', [(_vm.voucher) ? _c('div', {
    staticClass: "ui positive message"
  }, [_c('p', [_vm._v("A discount of\n            "), _c('strong', [(_vm.voucher.deduct.percentage > 0) ? _c('span', [_vm._v("-" + _vm._s(_vm.voucher.deduct.percentage * 100) + "%")]) : _vm._e(), _vm._v(" "), (_vm.voucher.deduct.percentage > 0 && _vm.voucher.deduct.absolute > 0) ? _c('span', [_vm._v(" and ")]) : _vm._e(), _vm._v(" "), (_vm.voucher.deduct.absolute > 0) ? _c('span', [_vm._v("-" + _vm._s(_vm.voucher.deduct.absolute) + ".00€")]) : _vm._e()]), _vm._v("\n            is applied to this booking.\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.title),
      expression: "contact.title"
    }],
    staticClass: "ui selection dropdown",
    attrs: {
      "name": "title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.contact.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Herr"
    }
  }, [_vm._v("Herr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Frau"
    }
  }, [_vm._v("Frau")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dr"
    }
  }, [_vm._v("Dr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Prof"
    }
  }, [_vm._v("Prof")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mag"
    }
  }, [_vm._v("Mag")])])]), _vm._v(" "), _c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.firstName),
      expression: "contact.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.contact.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.lastName),
      expression: "contact.lastName"
    }],
    attrs: {
      "type": "text",
      "name": "lastName"
    },
    domProps: {
      "value": (_vm.contact.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Company")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.company),
      expression: "contact.company"
    }],
    attrs: {
      "type": "text",
      "name": "company"
    },
    domProps: {
      "value": (_vm.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.company = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Telephone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.tel),
      expression: "contact.tel"
    }],
    attrs: {
      "type": "text",
      "name": "tel"
    },
    domProps: {
      "value": (_vm.contact.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.address),
      expression: "contact.address"
    }],
    attrs: {
      "type": "text",
      "name": "address"
    },
    domProps: {
      "value": (_vm.contact.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('div', {
    staticClass: "ten wide field"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.city),
      expression: "contact.city"
    }],
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.contact.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "six wide field"
  }, [_c('label', [_vm._v("Post Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.zip),
      expression: "contact.zip"
    }],
    attrs: {
      "type": "text",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.contact.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.zip = $event.target.value
      }
    }
  })])])], 2)]), _vm._v(" "), _c('table', {
    staticClass: "ui bottom attached basic table"
  }, [_c('tbody', [_vm._l((_vm.selected), function(booking) {
    return _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(booking.boat.name) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(booking.hour) + " h\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.moment(booking.date).format('ll')) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v("\n          €" + _vm._s(booking.cost) + ".00\n        ")])])
  }), _vm._v(" "), _vm._l((_vm.additionalServices), function(service) {
    return (service.selected) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v("\n          " + _vm._s(service.title) + " "), (service.priceType === 'perPerson' && _vm.details.numPeople) ? _c('span', [_vm._v("x" + _vm._s(_vm.details.numPeople))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [(service.priceType === 'perPerson' && _vm.details.numPeople) ? _c('span', [_vm._v("€" + _vm._s(_vm.numeral(service.price * _vm.details.numPeople).format('0,0.00')))]) : _c('span', [_vm._v("€" + _vm._s(_vm.numeral(service.price).format('0,0.00')))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.voucher) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Voucher:")]), _vm._v(" " + _vm._s(_vm.voucher.code))])]) : _vm._e(), _vm._v(" "), (_vm.voucher && _vm.voucher.deduct.absolute > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- €" + _vm._s(_vm.voucher.deduct.absolute) + ".00")])]) : _vm._e(), _vm._v(" "), (_vm.voucher && _vm.voucher.deduct.percentage > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "right aligned"
  }, [_vm._v("- " + _vm._s(_vm.voucher.deduct.percentage * 100) + "%")])]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('th', {
    staticClass: "right aligned"
  }, [_c('strong', [_vm._v("€" + _vm._s(_vm.totalCost))])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui positive button",
    on: {
      "click": _vm.reserve
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Add Reservation\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19df85d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/NewReservationModal.vue
// module id = 731
// module chunks = 1